<template>
  <div class="mt-6">
    <UpgradeBanner v-if="currentUser && !currentUser.upgraded" />
    <h1 class="title is-1">{{ $t("CSV.upload_csv") }}</h1>
    <p>{{ $t("CSV.upload_csv_title") }}</p>
    <br />
    <div class="p-grid p-justify-center" v-if="currentSeason">
      <div class="p-col-6">
        <h2 class="title is-3">
          {{ $t("Division.divisions") }}
          <span v-if="currentSeason.divisions.length"> ({{ currentSeason.divisions.length }}) </span>
        </h2>
        <a href="/csvs/divisions.csv" target="_blank"> {{ $t("CSV.download_sample_file") }}</a>
        <PapaParse @save="doDivisions" item="division"></PapaParse>
      </div>
      <div class="p-col-6">
        <h2 class="title is-3">
          {{ $t("Team.teams") }}
          <span v-if="currentSeason.teams.length"> ({{ currentSeason.teams.length }}) </span>
        </h2>
        <a href="/csvs/teams.csv" target="_blank">{{ $t("CSV.download_sample_file") }}</a>
        <PapaParse @save="doTeams" item="team"></PapaParse>
      </div>
      <div class="p-col-6">
        <br />
        <h2 class="title is-3">
          {{ $t("Venue.venues") }}
          <span v-if="currentSeason.venues.length"> ({{ currentSeason.venues.length }}) </span>
        </h2>
        <a href="/csvs/venues.csv" target="_blank"> {{ $t("CSV.download_sample_file") }}</a>
        <PapaParse @save="doVenues" item="venue"></PapaParse>
      </div>
      <div class="p-col-6">
        <br />
        <h2 class="title is-3">
          {{ $t("People.people") }}
          <span v-if="currentSeason.people.length"> ({{ currentSeason.people.length }}) </span>
        </h2>
        <a href="/csvs/people.csv" target="_blank"> {{ $t("CSV.download_sample_file") }}</a>
        <PapaParse @save="doPeople" item="person"></PapaParse>
      </div>
      <div class="p-col-6">
        <br />
        <h2 class="title is-3">{{ $t("Timeslot.timeslots") }}</h2>
        <a href="/csvs/timeslots.csv" target="_blank"> {{ $t("CSV.download_sample_file") }}</a>
        <PapaParse @save="doTimeslots" item="timeslot"></PapaParse>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  components: {},
  data() {
    return {
      value: 1,
      value2: 1,
    };
  },
  methods: {
    doTimeslots(links) {
      console.log("doPeople", links);
      api
        .createBulkTimeslots(this.$store.getters.currentSeason.id, links)
        .then(response => {
          this.makeToast("success", this.$t("Toast.created-timeslots-from-csv"));
          if (!this.isProduction) {
            this.$store.dispatch("getLeagueInformation");
          }
          console.log(response);
          // setTimeout(()=> {
          //   this.goRouter("/timeslots");
          // }, 750)
        })
        .catch(error => {
          alert(this.errors);
        });
    },
    doPeople(links) {
      console.log("doPeople", links);
      api
        .createBulkPeople(this.$store.getters.currentSeason.id, links)
        .then(response => {
          this.makeToast("success", this.$t("Toast.created-people-from-csv"));
          if (this.isProduction) {
            this.$store.dispatch("getLeagueInformation");
          }
          // this.goRouter("/");
          console.log(response);
        })
        .catch(error => {
          alert(this.errors);
        });
    },
    doTeams(links) {
      console.log("DoTeams", links);
      api
        .createBulkTeams(this.$store.getters.currentSeason.id, links)
        .then(response => {
          this.makeToast("success", this.$t("Toast.team_created"));
          this.$store.dispatch("getLeagueInformation");
          // this.goRouter("/");
          console.log(response);
        })
        .catch(error => {
          alert(this.errors);
        });
    },
    doDivisions(links) {
      console.log("DoDivs", links);
      api
        .createBulkDivisions(this.$store.getters.currentSeason.id, links)
        .then(response => {
          this.makeToast("success", this.$t("Toast.division_created"));
          this.$store.dispatch("getLeagueInformation");
          // this.goRouter("/");
          console.log(response);
        })
        .catch(error => {
          alert(this.errors);
        });
    },
    doVenues(links) {
      console.log("doVenues", links);
      api
        .createBulkVenues(this.$store.getters.currentSeason.id, links)
        .then(response => {
          this.makeToast("success", this.$t("Toast.venue_created"));
          this.$store.dispatch("getLeagueInformation");
          // this.goRouter("/");
          console.log(response);
        })
        .catch(error => {
          alert(this.errors);
        });
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.noLeagues) {
        alert(this.$t("CSV.alert.create"));
        this.goRouter("/leagues/new?return=/import/csv");
      }
    }, 2000);
  },
};
</script>

<style scoped lang="scss"></style>
